import type { GooglePlacePhoto } from "@albertine/types";
import type { CatalogImage } from "../../common/CatalogItem";

export type LocalFileReference = {
    type: "local";
    file: File;
};

export type ExternalFileReference = {
    type: "external";
    url: string;
};

export type LibraryFileReference = {
    type: "library";
    file: {
        id: string;
        filename: string;
    };
};

export type ImageReference =
    | LocalFileReference
    | ExternalFileReference
    | LibraryFileReference;

export function isLocalReference(
    possible: ImageReference,
): possible is LocalFileReference {
    return possible.type === "local";
}

export function isExternalReference(
    possible: ImageReference,
): possible is ExternalFileReference {
    return possible.type === "external";
}

export function getUrlFromReference(reference: ImageReference) {
    if (reference.type === "local") {
        return URL.createObjectURL(reference.file);
    }

    if (reference.type === "external") {
        return reference.url;
    }

    return reference.file.filename;
}

export function itemImagesToImageReferences(
    images: CatalogImage[],
): LibraryFileReference[] | undefined {
    if (!images) {
        return undefined;
    }
    const imageReferences = images?.map((image) => ({
        file: { id: image.id, filename: image.url },
        type: "library" as const,
    }));

    return imageReferences;
}

export function placeImagesToImageReferences(
    images: GooglePlacePhoto[],
): ExternalFileReference[] | undefined {
    if (!images) {
        return undefined;
    }
    const imageReferences = images?.map((image) => ({
        type: "external" as const,
        url: image.photoUri || "",
    }));

    return imageReferences;
}
